import type { Point2d } from "@logic/lib/2d"
import { pointsToBox } from "@logic/lib/2d"
import { atom, selector } from "recoil"

import { findProjectedMouseState } from "~/hooks/useMousePosition"

import { toolState } from "./tool"

export const studioMouseState = selector({
  key: `inputs_mouse`,
  get: ({ get }) => get(findProjectedMouseState([`Studio`, `Studio`])),
})

export const startPointState = atom<Point2d | null>({
  key: `inputs_startPoint`,
  default: null,
})

export const dragBoxState = selector<ReturnType<typeof pointsToBox> | null>({
  key: `inputs_dragBox`,
  get: ({ get }) => {
    const mouse = get(studioMouseState)
    const currentTool = get(toolState)
    const startPoint = get(startPointState)
    if (
      startPoint &&
      (currentTool === `Select` || currentTool === `PanelActivator`)
    ) {
      return pointsToBox(startPoint, mouse)
    }

    return null
  },
})

export const shiftIsDownState = atom<boolean>({
  key: `inputs_shiftIsDown`,
  default: false,
})
